module.exports = __webpack_public_path__ + "img/avatar.0de3c088.png";